import { Grid, TableRow } from "@mui/material";

import { GenericTable } from "~/components/GenericTable/GenericTable";
import {
  ImpactCell,
  PublishedCell,
  RiskFactorsCell,
  TitleCell,
} from "~/components/Cells";
import { ScoreRating } from "~/operations";
import { DynamicIcon } from "~/components/icons/DynamicIcon";
import { ReportsNoItemsSection } from "../../components";
import { AggregateScoresEdges } from "../utils/securityReportTypes";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

interface AssetsProps {
  assets: AggregateScoresEdges;
}

export function SecurityReportAssets({ assets }: AssetsProps) {
  const totalAssets = assets?.length || 0;
  return (
    <>
      <ReportsSectionHeading
        heading="Assets"
        dividerContent={`${totalAssets} Total`}
      />
      <Grid size={12} sx={{ my: 3 }}>
        {!assets ? (
          <ReportsNoItemsSection target="Assets" />
        ) : (
          <GenericTable
            items={0}
            tableName="SECURITY_REPORT_ASSETS"
            validSortFields={[]}
            printView
          >
            {assets?.map((asset) => {
              const {
                id,
                riskValue,
                rating,
                title,
                iconId,
                tags,
                riskFactors,
                lastScannedAt,
              } = asset.node || {};
              return (
                <TableRow key={id}>
                  <ImpactCell
                    impact={riskValue || 0}
                    rating={rating || ScoreRating.Critical}
                    isActive
                    hideTooltip
                  />
                  <TitleCell
                    title={title || ""}
                    icon={<DynamicIcon iconId={iconId} />}
                    tags={tags}
                    options={{ fontSize: 14 }}
                  />
                  <RiskFactorsCell riskFactors={riskFactors} />
                  <PublishedCell date={lastScannedAt || "Never"} />
                </TableRow>
              );
            })}
          </GenericTable>
        )}
      </Grid>
    </>
  );
}
